export default __webpack_public_path__ + "static/media/img_post1.af4c9858.png";